import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle, Form, Modal, ModalHeader, ModalBody, Table, Row, Col } from 'reactstrap';
import { QRCodeSVG } from 'qrcode.react';
import axios from 'axios';
import config from '../config';
import { usePermissions } from '../Components/Hooks/PermissionHooks';

//import images
//import logoSm from "../assets/images/logo-sm.png";
//import logoDark from "../assets/images/logo-dark.png";
//import logoLight from "../assets/images/logo-light.png";

//import Components
import SearchOption from '../Components/Common/SearchOption';
import WebAppsDropdown from '../Components/Common/WebAppsDropdown';
import FullScreenDropdown from '../Components/Common/FullScreenDropdown';
import NotificationDropdown from '../Components/Common/NotificationDropdown';
import ProfileDropdown from '../Components/Common/ProfileDropdown';
import LightDark from '../Components/Common/LightDark';
import QuickBugReport from '../Components/Common/QuickBugReport';
import ClockDisplay from '../Components/Common/ClockDisplay';

import { changeSidebarVisibility } from '../slices/thunks';
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass } : any) => {
    const dispatch : any = useDispatch();
    const navigate = useNavigate();
    const { user, isAdmin } = usePermissions();


    const selectDashboardData = createSelector(
        (state) => state.Layout,
        (sidebarVisibilitytype) => sidebarVisibilitytype.sidebarVisibilitytype
      );
    // Inside your component
    const sidebarVisibilitytype = useSelector(selectDashboardData);
    

    const [search, setSearch] = useState<boolean>(false);
    const [showShortcutsModal, setShowShortcutsModal] = useState<boolean>(false);
    const [showBugReportModal, setShowBugReportModal] = useState<boolean>(false);
    const [openBugCount, setOpenBugCount] = useState<number>(0);
    const [vGeldBalance, setVGeldBalance] = useState<number>(0);
    
    const toogleSearch = () => {
        setSearch(!search);
    };
    
    const toggleShortcutsModal = () => {
        setShowShortcutsModal(!showShortcutsModal);
    };
    
    const toggleBugReportModal = () => {
        setShowBugReportModal(!showBugReportModal);
    };
    
    // Load bug report stats for admins and V-Geld balance
    useEffect(() => {
        let isAuthorized = true;
        
        const loadBugStats = async () => {
            if (!isAuthorized) return;
            
            try {
                const response = await axios.get(`${config.api.API_URL}/bug-reports/stats`);
                if (response.data.success) {
                    setOpenBugCount(response.data.data.open_count || 0);
                }
            } catch (error: any) {
                // Stop polling if unauthorized
                if (error?.response?.status === 401) {
                    isAuthorized = false;
                }
                // Silently fail for other errors - user might not have permission
            }
        };
        
        const loadVGeldBalance = async () => {
            if (!isAuthorized) return;
            
            try {
                const response = await axios.get(`${config.api.API_URL}/expense-reports/balance`);
                if (response.data.success) {
                    setVGeldBalance(response.data.data.balance || 0);
                }
            } catch (error: any) {
                // Stop polling if unauthorized  
                if (error?.response?.status === 401) {
                    isAuthorized = false;
                }
                console.error('Error loading V-Geld balance:', error);
            }
        };
        
        loadBugStats();
        loadVGeldBalance();
        
        // Refresh every 30 seconds for more real-time updates
        const interval = setInterval(() => {
            if (isAuthorized) {
                loadBugStats();
                loadVGeldBalance();
            }
        }, 30 * 1000); // 30 seconds
        
        return () => clearInterval(interval);
    }, []);

    const toogleMenuBtn = () => {
        // Add null checks for document elements
        if (!document.documentElement || !document.body) {
            return;
        }
        
        var windowSize = document.documentElement.clientWidth;
        const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;
        dispatch(changeSidebarVisibility("show"));

        if (windowSize > 767 && humberIcon)
            humberIcon.classList.toggle('open');

        // Cache layout and sidebar size attributes to avoid multiple DOM accesses
        const dataLayout = document.documentElement ? document.documentElement.getAttribute('data-layout') : null;
        const dataSidebarSize = document.documentElement ? document.documentElement.getAttribute('data-sidebar-size') : null;

        //For collapse horizontal menu
        if (dataLayout === "horizontal") {
            document.body.classList.contains("menu") ? document.body.classList.remove("menu") : document.body.classList.add("menu");
        }

        //For collapse vertical and semibox menu
        if (sidebarVisibilitytype === "show" && (dataLayout === "vertical" || dataLayout === "semibox")) {
            if (windowSize < 1025 && windowSize > 767) {
                document.body.classList.remove('vertical-sidebar-enable');
                if (document.documentElement) {
                    (dataSidebarSize === 'sm') ? document.documentElement.setAttribute('data-sidebar-size', '') : document.documentElement.setAttribute('data-sidebar-size', 'sm');
                }
            } else if (windowSize > 1025) {
                document.body.classList.remove('vertical-sidebar-enable');
                if (document.documentElement) {
                    (dataSidebarSize === 'lg') ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'lg');
                }
            } else if (windowSize <= 767) {
                document.body.classList.add('vertical-sidebar-enable');
                if (document.documentElement) {
                    document.documentElement.setAttribute('data-sidebar-size', 'lg');
                }
            }
        }


        //Two column menu
        if (dataLayout === "twocolumn") {
            document.body.classList.contains('twocolumn-panel') ? document.body.classList.remove('twocolumn-panel') : document.body.classList.add('twocolumn-panel');
        }
    };

    return (
        <React.Fragment>
            <header id="page-topbar" className={headerClass}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex">

                            <div className="navbar-brand-box horizontal-logo">
                                <Link to="/" className="logo logo-dark">
                                    <span className="logo-sm">
                                        <img src="/assets/images/space_logo_final_centered.svg" alt="logo" height="22" />
                                    </span>
                                    <span className="logo-lg">
                                        <img src="/assets/images/space_logo_final_centered.svg" alt="logo" height="32" />
                                    </span>
                                </Link>

                                <Link to="/" className="logo logo-light">
                                    <span className="logo-sm">
                                        <img src="/assets/images/space_logo_final_centered.svg" alt="logo" height="22" />
                                    </span>
                                    <span className="logo-lg">
                                        <img src="/assets/images/space_logo_final_centered.svg" alt="logo" height="32" />
                                    </span>
                                </Link>
                            </div>

                            <button
                                onClick={toogleMenuBtn}
                                type="button"
                                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                                id="topnav-hamburger-icon">
                                <span className="hamburger-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>


                            <SearchOption />
                        </div>

                        <div className="d-flex align-items-center">

                            <Dropdown isOpen={search} toggle={toogleSearch} className="d-md-none topbar-head-dropdown header-item">
                                <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                                    <i className="bx bx-search fs-22"></i>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                                    <Form className="p-3">
                                        <div className="form-group m-0">
                                            <div className="input-group">
                                                <input type="text" className="form-control" placeholder="Search ..."
                                                    aria-label="Recipient's username" />
                                                <button className="btn btn-primary" type="submit"><i
                                                    className="mdi mdi-magnify"></i></button>
                                            </div>
                                        </div>
                                    </Form>
                                </DropdownMenu>
                            </Dropdown>

                            {/* Keyboard Shortcuts Info Button */}
                            <div className="ms-1 header-item d-none d-sm-flex">
                                <button
                                    type="button"
                                    className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                                    onClick={toggleShortcutsModal}
                                    title="Tastenkombinationen"
                                >
                                    <i className="ri-information-line fs-22"></i>
                                </button>
                            </div>

                            {/* WebAppsDropdown */}
                            <WebAppsDropdown />

                            {/* V-Geld Balance (replacing MyCartDropdown) - Only show if user has permission */}
                            {(isAdmin() || (user?.menuPermissions && user.menuPermissions.includes('expensereports'))) && (
                                <div className="ms-1 header-item d-none d-sm-flex">
                                    <button
                                        type="button"
                                        className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle position-relative"
                                        onClick={() => navigate('/expense-reports')}
                                        title="V-Geld Guthaben"
                                    >
                                        <i className="bx bx-shopping-bag fs-22"></i>
                                        {vGeldBalance > 0 && (
                                            <span className="position-absolute topbar-badge cartitem-badge fs-10 translate-middle badge rounded-pill bg-info">
                                                {vGeldBalance.toLocaleString('de-DE', { 
                                                    style: 'currency', 
                                                    currency: 'EUR',
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0
                                                })}
                                                <span className="visually-hidden">V-Geld Guthaben</span>
                                            </span>
                                        )}
                                    </button>
                                </div>
                            )}

                            {/* Clock Display - Show active clock if exists */}
                            <ClockDisplay />

                            {/* Bug Report Button */}
                            <div className="ms-1 header-item d-none d-sm-flex">
                                <button
                                    type="button"
                                    id="quick-bug-report"
                                    className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle position-relative"
                                    onClick={toggleBugReportModal}
                                    title="Bug Report (Strg+B)"
                                >
                                    <i className="ri-bug-line fs-22"></i>
                                    {openBugCount > 0 && (
                                        <span className="position-absolute badge rounded-pill bg-danger">
                                            {openBugCount}
                                            <span className="visually-hidden">offene Bugs</span>
                                        </span>
                                    )}
                                </button>
                            </div>

                            {/* FullScreenDropdown */}
                            <FullScreenDropdown />

                            {/* Dark/Light Mode set */}
                            <LightDark
                                layoutMode={layoutModeType}
                                onChangeLayoutMode={onChangeLayoutMode}
                            />

                            {/* NotificationDropdown */}
                            <NotificationDropdown />

                            {/* ProfileDropdown */}
                            <ProfileDropdown />
                        </div>
                    </div>
                </div>
            </header>

            {/* Keyboard Shortcuts Modal */}
            <Modal isOpen={showShortcutsModal} toggle={toggleShortcutsModal} size="lg">
                <ModalHeader toggle={toggleShortcutsModal}>
                    <i className="ri-keyboard-box-line me-2"></i>
                    Tastenkombinationen
                </ModalHeader>
                <ModalBody>
                    <div className="mb-4">
                        <h5 className="mb-3">Globale Tastenkombinationen</h5>
                        <Table className="table-bordered">
                            <thead>
                                <tr>
                                    <th style={{ width: '40%' }}>Tastenkombination</th>
                                    <th>Aktion</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <kbd>Strg</kbd> + <kbd>K</kbd> / <kbd>Cmd</kbd> + <kbd>K</kbd>
                                    </td>
                                    <td>Mastersuche öffnen</td>
                                </tr>
                                <tr>
                                    <td>
                                        <kbd>Strg</kbd> + <kbd>J</kbd> / <kbd>Cmd</kbd> + <kbd>J</kbd>
                                    </td>
                                    <td>Neue Aufgabe erstellen</td>
                                </tr>
                                <tr>
                                    <td>
                                        <kbd>Strg</kbd> + <kbd>M</kbd> / <kbd>Cmd</kbd> + <kbd>M</kbd>
                                    </td>
                                    <td>Nachricht senden</td>
                                </tr>
                                <tr>
                                    <td>
                                        <kbd>Strg</kbd> + <kbd>T</kbd> / <kbd>Cmd</kbd> + <kbd>T</kbd>
                                    </td>
                                    <td>Schnelle Zeiterfassung öffnen</td>
                                </tr>
                                <tr>
                                    <td>
                                        <kbd>Strg</kbd> + <kbd>B</kbd> / <kbd>Cmd</kbd> + <kbd>B</kbd>
                                    </td>
                                    <td>Bug Report erstellen</td>
                                </tr>
                                <tr>
                                    <td>
                                        <kbd>ESC</kbd>
                                    </td>
                                    <td>Aktuelle Aktion/Modal schließen</td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                    
                    <div className="mb-4">
                        <h5 className="mb-3">Master Spotlight Navigation (Strg+K)</h5>
                        <Table className="table-bordered">
                            <thead>
                                <tr>
                                    <th style={{ width: '40%' }}>Tastenkombination</th>
                                    <th>Aktion</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <kbd>↑</kbd> / <kbd>↓</kbd>
                                    </td>
                                    <td>In Suchergebnissen navigieren</td>
                                </tr>
                                <tr>
                                    <td>
                                        <kbd>Enter</kbd>
                                    </td>
                                    <td>Ausgewähltes Suchergebnis öffnen</td>
                                </tr>
                                <tr>
                                    <td>
                                        <code>@</code>username
                                    </td>
                                    <td>Nach Benutzern suchen</td>
                                </tr>
                                <tr>
                                    <td>
                                        <code>/</code>projektname
                                    </td>
                                    <td>Nach Projekten suchen</td>
                                </tr>
                                <tr>
                                    <td>
                                        <code>#</code>taskname
                                    </td>
                                    <td>Nach Aufgaben suchen</td>
                                </tr>
                                <tr>
                                    <td>
                                        <code>$</code>geld
                                    </td>
                                    <td>Verrechnungsgeld anfordern</td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                    
                    <div className="alert alert-secondary">
                        <i className="ri-code-line me-2"></i>
                        <strong>Weitere Shortcuts können hinzugefügt werden!</strong><br/>
                        Die Tastenkombinationen werden in der Datei <code>GlobalKeyboardShortcuts.tsx</code> definiert.
                    </div>

                    <div className="alert alert-info">
                        <i className="ri-lightbulb-line me-2"></i>
                        <strong>Tipp:</strong> Die meisten Tastenkombinationen funktionieren überall in der Anwendung,
                        außer wenn Sie sich in einem Eingabefeld befinden.
                    </div>

                    <Row className="mt-4 g-3">
                        <Col md={6}>
                            <div className="border rounded p-3 bg-light h-100">
                                <Row className="align-items-center">
                                    <Col xs="auto">
                                        <div className="bg-white p-2 rounded shadow-sm">
                                            <QRCodeSVG
                                                value="https://testflight.apple.com/join/uSJTfZ6a"
                                                size={80}
                                                level="M"
                                                includeMargin={false}
                                            />
                                        </div>
                                    </Col>
                                    <Col>
                                        <h6 className="mb-1">
                                            <i className="ri-apple-fill me-2"></i>
                                            iOS App
                                        </h6>
                                        <p className="text-muted small mb-2">
                                            Native App über TestFlight installieren
                                        </p>
                                        <a
                                            href="https://testflight.apple.com/join/uSJTfZ6a"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-sm btn-primary"
                                        >
                                            <i className="ri-external-link-line me-1"></i>
                                            TestFlight
                                        </a>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="border rounded p-3 bg-light h-100">
                                <Row className="align-items-center">
                                    <Col xs="auto">
                                        <div className="bg-white p-2 rounded shadow-sm">
                                            <QRCodeSVG
                                                value="https://beta.mxr.space/public/door"
                                                size={80}
                                                level="M"
                                                includeMargin={false}
                                            />
                                        </div>
                                    </Col>
                                    <Col>
                                        <h6 className="mb-1">
                                            <i className="ri-door-open-line me-2"></i>
                                            Türöffner (Web)
                                        </h6>
                                        <p className="text-muted small mb-2">
                                            Alternative für Android & andere Geräte
                                        </p>
                                        <a
                                            href="/public/door"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-sm btn-secondary"
                                        >
                                            <i className="ri-door-open-line me-1"></i>
                                            Web-Türöffner
                                        </a>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>

            {/* Quick Bug Report Modal */}
            <QuickBugReport isOpen={showBugReportModal} toggle={toggleBugReportModal} />
        </React.Fragment>
    );
};

export default Header;